var _clipPath, _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSquare = function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    viewBox: "0 0 271 271"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-square",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 1 0, 1 0.9785, 0 0.9785"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "2 2, 268 2, 268 268, 2 268"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwcHgiIHZpZXdCb3g9IjAgMCAyNzEgMjcxIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICA8Y2xpcFBhdGggaWQ9ImNsaXAtc3F1YXJlIiBjbGlwUGF0aFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICA8cG9seWdvbiBwb2ludHM9IjAgMCwgMSAwLCAxIDAuOTc4NSwgMCAwLjk3ODUiLz4KICA8L2NsaXBQYXRoPgogIDxwb2x5Z29uIHBvaW50cz0iMiAyLCAyNjggMiwgMjY4IDI2OCwgMiAyNjgiIC8+Cjwvc3ZnPgo=";
export { SvgSquare as ReactComponent };